import { Ref } from 'vue'

import { SubParticipant } from '@collector/sportsapi-client-legacy'
import router from '@mobile/router'

import { updateSubParticipants as _updateSubParticipants } from './Sports/Cricket/CricketRelationDependencies/bindEventSubParticipants/utils'
import { CricketRelationIoCBindings } from './Sports/Cricket/CricketRelationDependencies/CricketRelationDependencies'

export type UseEventSubParticipants = {
  updateSubParticipants: (subParticipants: SubParticipant[]) => void
  eventSubParticipants: Ref<SubParticipant[]>
}

export function useEventSubParticipants(): UseEventSubParticipants {
  const ioc = router.currentRoute.value.meta.ioc
  if (!ioc) {
    throw Error(
      'IoC Container has to be instantiated and injected into route meta before using event sub participants',
    )
  }

  // inject
  const eventSubParticipants = ioc.get(
    CricketRelationIoCBindings.EventSubParticipants,
  )

  // methods
  function updateSubParticipants(subParticipants: SubParticipant[]): void {
    _updateSubParticipants(subParticipants, eventSubParticipants)
  }

  return {
    updateSubParticipants,
    eventSubParticipants,
  }
}
